<template>
  <div @click="onclick">Log out</div>
</template>

<script>
  import {ROUTE} from "../router";
  import {resetData} from "@/api";

  export default {
    name: "Logout",
    methods: {
      onclick() {
        resetData()
        this.$router.push({name: ROUTE.LOGIN})
      }
    }
  }
</script>

<style scoped>

</style>